export class SongsEmptySectionsRemover {
  constructor(songsJson, showChords = true) {
    this.songsJson = songsJson;
    this.showChords = showChords;
    // console.log(`SongsEmptySectionsRemover initialized with showChords=${showChords}`);
  }

  removeEmptySections() {
    this.songsJson.songs.forEach((song, songIdx) => {
      song.sections = song.sections.filter((section, sectionIdx) => {
        return this.hasVisibleContent(section);
      });
    });

    return this.songsJson;
  }

  static isVisibleSection(section, showChords = true) {
    const remover = new SongsEmptySectionsRemover(null, showChords);
    return remover.hasVisibleContent(section);
  }

  hasVisibleContent(section) {
    return section.content.some(lineGroup =>
      lineGroup.some(line => this.isVisibleLine(line))
    );
  }

  isVisibleLine(line) {
    if (line.type === 'text') {
      // Text is visible if it's not empty and not a meta tag
      return line.content.trim() !== '' && !line.content.match(/^\s*\[(.*)\]\s*$/)
        && !/^\s*(?:\/\/|\/)?\s*(?:x\s*\d+|\d+\s*x)\s*$/i.test(line.content);
    }

    if (line.type === 'inline-lyrics') {
      // Inline lyrics are visible if they have any non-whitespace segments
      const text = line.segments?.map(segment => segment.text).join('') ?? '';
      return line.segments && line.segments.some(s => !s.isWhitespace && s.text.trim())
        && !/^\s*(?:\/\/|\/)?\s*(?:x\s*\d+|\d+\s*x)\s*$/i.test(text);
    }

    // Chords are visible only if showChords is enabled
    if (line.type === 'chord') {
      return this.showChords;
    }

    // Unknown line types are considered not visible
    // console.log(`Unknown line type: ${line.type}`);
    return false;
  }
}
